import React, { useEffect } from "react";


function Popup({ title, popup_note, form, onChildClick }) {

  useEffect(() => {
    document.body.addEventListener("keydown", (e) => keyDownClick(e));
  });

  // ESC Click
  function keyDownClick(e) {
    // Hide Popup
    return e.keyCode === 27 ? onChildClick() : "";
  }

  // Popup Close
  function closePopup(data) {
    onChildClick(data);
  }

  return (
    <React.Fragment>
      <div className="sd_popup">
        <div className="sd_popup_inner">
          {title ? (
            <div className="sd_popup_header">
              <h3>{title}</h3>
            </div>
          ) : (
            ""
          )}
          <div className="sd_popup_content">
            {Object.values(popup_note).map((note) => {
              return <p>{note}</p>;
            })}

              <div className="sd_popup_buttons sd_popup_confirm_buttons">
                <button
                  className="sd_grey_btn"
                  type="button"
                  onClick={closePopup}
                >
                  OK
                </button>
              </div>           
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default Popup;
